import ProgressiveBars from './ProgressiveBars';

export default ProgressiveBars;
